import RadioListImages from "../images/RadioListImages";

export default class RadioListEmotionSignature extends RadioListImages {
    protected get columnCount():number {
        return 0; // Use default column count by device screen size
    }
}